import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=5b04ad4a"
import script from "./UserRole.vue?vue&type=script&lang=js"
export * from "./UserRole.vue?vue&type=script&lang=js"
import style0 from "./UserRole.vue?vue&type=style&index=0&id=5b04ad4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports